// Common Yes/No Options
export const yesNoOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" }
];

// Standard Rando Node URL Options
export const standardRandoNodeUrlOptions = yesNoOptions;

// Embedded Ancillary Study Options
export const embeddedAncillaryStudyOptions = yesNoOptions;

// Slot Reservation Protocol Options
export const slotReservationProtocolOptions = yesNoOptions;

// IROC Credentialing Options
export const irocCredentialingOptions = yesNoOptions;

// Step Required Options
export const stepRequiredOptions = yesNoOptions;

// Patient Initialization Options
export const patientInitializationOptions = yesNoOptions;

// Transfer EC Data Options
export const transferEcDataOptions = yesNoOptions;

// Rave Protocol Options
export const raveProtocolOptions = yesNoOptions;

// SDP Supported Options
export const sdpSupportedOptions = [
  {
    value: true,
    label:
      "Yes (LPO should use Rave ALS version 6.0 or above for select registration trials and trials as determined by CTEP)"
  },
  { value: false, label: "No" }
];

// Rave CTEP AERS Integration Options
export const raveCtepAersIntOptions = [
  {
    value: true,
    label:
      "Yes (LPO should use latest Rave ALS version for all new CTEP IND trials)"
  },
  { value: false, label: "No" }
];

// TSDV Site Auditing Options
export const tsdvSiteAuditingOptions = [
  {
    value: true,
    label:
      "Yes (LPO should use Rave ALS version 5.2 or above for new Rave trials)"
  },
  { value: false, label: "No" }
];

// DQP Supported Options
export const dqpSupportedOptions = [
  { value: true, label: "Yes (Required for all new Rave trials)" },
  { value: false, label: "No" }
];

// Medidata Patient Cloud ePRO Options
export const medidataPatientCloudEproOptions = yesNoOptions;

// Required Triad Testing Options
export const requiredTriadTestingOptions = yesNoOptions;

// Study Rave Calendaring Options
export const studyRaveCalendaringOptions = yesNoOptions;

// Mandatory/Optional Options
export const mandatoryOptionalOptions = [
  {
    label: "Mandatory",
    value: "MANDATORY"
  },
  {
    label: "Optional",
    value: "OPTIONAL"
  }
];

// Required/Optional Options (for IROC)
export const requiredOptionalOptions = [
  {
    label: "Required",
    value: "MANDATORY"
  },
  {
    label: "Optional",
    value: "OPTIONAL"
  },
  {
    label:"At least one credentialing type is required",
    value:"MANDATORY_AT_LEAST_ONE"
  }
];

// Registration Type Options
export const registrationTypeOptions = [
  { label: "Patient", value: "Patient" },
  {
    label: "Non-Patient: Provider",
    value: "Non-Patient: Provider"
  },
  {
    label: "Non-Patient: Other Professional Discipline",
    value: "Non-Patient: Other Professional Discipline"
  },
  {
    label: "Non-Patient: Caregiver",
    value: "Non-Patient: Caregiver"
  },
  {
    label: "Non-Patient: Practice",
    value: "Non-Patient: Practice"
  },
  {
    label: "Non-Patient: Other",
    value: "Non-Patient: Other"
  }
];

// Open Rave Version Options
export const openRaveVersionOptions = [
  { value: "7.0 and above", label: "7.0 and above" },
  { value: "Below 7.0", label: "Below 7.0" }
];

// Patient Selection Method Options
export const patientSelectionMethodOptions = [
  { value: "All", label: "All" },
  { value: "Manual", label: "Manual" },
  {
    value: "First X by Arm, then every Y by Arm",
    label: "1st X patient by arm, then every Y patient by arm"
  },
  {
    value: "First X then every Y patient",
    label: "1st X patient, then every Y"
  }
];

// Change Options (from orHelpers.js)
export const changeOptions = [
  { value: "addQuestions", label: "Add questions" },
  { value: "removeQuestions", label: "Remove questions" },
  { value: "changeQuestions", label: "Change question setup" },
  { value: "majorWordingChange", label: "Major wording changes" },
  { value: "minorWordingChange", label: "Minor wording changes" },
  { value: "changeValidValues", label: "Change in option values" },
  { value: "editCheckUpdate", label: "Updates to edit checks" },
  { value: "raveInfoUpdate", label: "Update to Rave information" },
  { value: "otherChanges", label: "Other" }
];

// IND Type Options (from orHelpers.js)
export const indTypeOptions = [
  { value: "CTEP-held IND", label: "CTEP-held IND" },
  { value: "Non-CTEP held IND", label: "Non-CTEP held IND" },
  { value: "IND Exempt", label: "IND Exempt" },
  { value: "No Agent", label: "No Agent" }
];

// Protocol Type Options (from orHelpers.js)
export const protocolTypeOptions = [
  { value: "CC", label: "Cancer Control/Prevention" },
  { value: "CCRD", label: "Cancer Care Delivery Research (CCDR)" },
  { value: "Treatment", label: "Treatment" }
];

// Request Type Options (from orHelpers.js)
export const requestTypeOptions = [
  { value: "AMENDMENT", label: "Amendment" },
  { value: "NEW_SUBMISSION", label: "New Protocol" },
  { value: "CORRECTION", label: "Non-amendment revision" }
];
